<fgb-page-header [pageTitle]="'challenges.page.title'" />

<div class="mt-lg-3 container">
  <fgbcl-badge-achieved />
</div>
<!--Scorecard -->
<div class="position-relative z-1">
  <fgbcl-scorecard-list-view [icon]="'chevron_right'" [showPlaceholder]="true"></fgbcl-scorecard-list-view>
</div>
